import * as R from "ramda";
import { Cascader, message, Modal } from "antd";
import React, { useMemo, useState } from "react";

import { LabelNameOfResource } from "@/containers/Video/";
import {
  TreeNodeValueToTextMap,
  uploadResourceChannelMap,
  UploadResourceChannelToTextMap,
} from "@/containers/Video/tab-pages/video-resource-page";
import { useTagList } from "@/containers/Video/widgets/resource-tag-modal";

// noinspection JSNonASCIINames
/**
 * 选择视频源
 *
 * - 直播视频
 * - 视频创作素材 @LabelNameOfResource
 *  - 全部类型
 *  - 本地视频
 *    - 本地手动上传
 *    - 本地自动上传
 *  - 直播切片(直播视频切出来的片段)
 *  - 视频合成素材
 *  - 图传视频素材
 *
 */
const SelectVideoOptions = [
  {
    label: "直播视频",
    value: "live",
  },
  {
    label: LabelNameOfResource,
    value: "video",
    children: [
      {
        label: "全部类型",
        value: "0",
      },
      {
        label: "本地视频",
        value: `${uploadResourceChannelMap.本地自动上传},${uploadResourceChannelMap.本地手动上传}`,
        children: [
          {
            label:
              UploadResourceChannelToTextMap[
                uploadResourceChannelMap.本地手动上传
              ],
            value: `${uploadResourceChannelMap.本地手动上传}`,
          },
          {
            label:
              UploadResourceChannelToTextMap[
                uploadResourceChannelMap.本地自动上传
              ],
            value: `${uploadResourceChannelMap.本地自动上传}`,
          },
        ],
      },
      {
        label:
          UploadResourceChannelToTextMap[uploadResourceChannelMap.直播切片],
        value: `${uploadResourceChannelMap.直播切片}`,
      },
      /*{
        label: "视频合成素材",
        value: `${uploadResourceChannelMap.合成素材}`,
      },*/
      {
        label: TreeNodeValueToTextMap["0-9"],
        value: `${uploadResourceChannelMap.智能剪辑视频}`,
      },
      {
        label:
          UploadResourceChannelToTextMap[
            uploadResourceChannelMap["图传视频素材(APP)"]
          ],
        value: `${uploadResourceChannelMap["图传视频素材(APP)"]}`,
      },
    ],
  },
];

export const SelectVideoSource = ({ value = [], onChange }) => {
  const [state, setState] = useState({
    visible: false,
    //  选中的值
    selectedValue: value,
    // 临时选
    tempValue: value,
  });

  // 获取标签列表, 标签列表需要根据orderId获取
  const tagList = useTagList(window.decorateGetGallery().orderid, 0);

  const options = useMemo(() => {
    return SelectVideoOptions.map((item) => {
      //  只有三种, live, video, 6 => 智能剪辑视频
      switch (item.value) {
        case "video":
          const addTagsToChildren = (children) => {
            return children.map((child) => ({
              ...child,
              children: child.children
                ? addTagsToChildren(child.children)
                : [
                    ...(child.children || []),
                    ...tagList.map((tag) => ({
                      label: tag.name,
                      value: `${child.value}-${tag.id}`,
                    })),
                  ],
            }));
          };
          return {
            ...item,
            children: addTagsToChildren(item.children || []),
          };
        case "live":
          return item;
        default:
          return item;
      }
    });
  }, [tagList]);

  const handleOk = () => {
    const firstValue = R.path([0], state.tempValue);
    const secondValue = R.path([1], state.tempValue);

    const firstIsVideo = R.equals(firstValue, "video");
    const secondIsNil = R.isNil(secondValue);

    if (firstIsVideo && secondIsNil) {
      message.error("请选择下一级的视频源");
      return;
    }
    onChange(state.tempValue);
    setState({
      ...state,
      selectedValue: state.tempValue,
      visible: false,
    });
  };

  const handleCancel = () => {
    setState({
      ...state,
      visible: false,
    });
  };

  return (
    <>
      <Cascader
        style={{ width: "100%" }}
        value={R.pathOr([], ["selectedValue"], state)}
        options={options}
        popupVisible={false}
        onClick={() => {
          setState({
            ...state,
            visible: true,
          });
        }}
        allowClear={false}
      />
      <Modal
        title="选择视频源"
        visible={state.visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Cascader
          style={{ width: "100%" }}
          popupPlacement="topLeft"
          options={options}
          changeOnSelect
          value={R.pathOr([], ["tempValue"], state)}
          onChange={(value) => {
            setState({
              ...state,
              tempValue: value,
            });
          }}
        />
      </Modal>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/Select/video-source-select.js